// Login form constants
export const LOGIN_CONSTANTS = {
  MIN_PASSWORD_LENGTH: 8,
  ERROR_MESSAGES: {
    INVALID_EMAIL: 'Invalid email address',
    REQUIRED_EMAIL: 'Email is required',
    REQUIRED_PASSWORD: 'Password is required',
    PASSWORD_TOO_SHORT: 'Password must be at least 8 characters',
    DEVICE_RESTRICTED: 'Access Restricted',
    DEVICE_MESSAGE: 'Please use the same device from which you originally registered, or contact support for assistance.'
  }
};